"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BillDetailDialog',
  data: function data() {
    return {
      dialogVisible: false,
      // 静态 mock 数据
      detail: {
        billNo: 'SA2026052500214',
        reconciliationStatus: '已核对',
        merchantName: '家家乐',
        paymentStatus: '已打款',
        merchantType: '核销商家',
        periodStart: '2025-05-29 19:40:11',
        periodEnd: '2025-05-29 19:40:11',
        generateTime: '2025-05-29 19:40:11',
        creatorName: '张三',
        merchantRemark: '备注',
        reconciliationRemark: '备注',
        orderDataFile: '2025年3月账单.xls',
        orderAmount: 100,
        orderCount: 120,
        settledAmount: 100,
        actualAmount: 100
      }
    };
  },
  methods: {
    open: function open(row) {
      if (row) {
        this.detail.billNo = row.billNo || this.detail.billNo;
        this.detail.merchantName = row.merchantName || this.detail.merchantName;
        this.detail.merchantType = row.merchantType || this.detail.merchantType;
        this.detail.creatorName = row.creatorName || this.detail.creatorName;
      }
      this.dialogVisible = true;
    }
  }
};